<template>
  <div class="p-signageQR">
    <img
      class="p-signageQR__check"
      src="/img/shop/img_qrcodeDecolation_check.png"
    />
    <div class="p-signageQR__img">
      <canvas ref="canvas" class="p-signageQR__canvas" />
    </div>
    <img
      v-if="$i18n.locale === 'en'"
      class="p-signageQR__balloon p-signageQR__balloon--pc"
      src="/img/shop/img_read_more_balloon_en.svg"
    />
    <img
      v-else
      class="p-signageQR__balloon p-signageQR__balloon--pc"
      src="/img/shop/img_read_more_balloon.svg"
    />
    <img
      v-if="$i18n.locale === 'en'"
      class="p-signageQR__balloon p-signageQR__balloon--smp"
      src="/img/shop/img_read_more_balloon_en_mobile.svg"
    />
    <img
      v-else
      class="p-signageQR__balloon p-signageQR__balloon--smp"
      src="/img/shop/img_read_more_balloon_mobile.svg"
    />
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'PSignageQR',
  props: {
    qrString: {
      type: String,
      required: true,
    },
  },
  mounted() {
    QRCode.toCanvas(this.$refs.canvas, this.qrString, (error) => {
      if (error) this.$toasted.show(error)
    })
  },
}
</script>
